export const REGISTRATION_QUERY_KEY = ["registration", "security-questions"];
export const REGISTRATION_SUCCESS_MESSAGE = "Account created successfully! Welcome to Watch Tower.";
export const REGISTRATION_INITIAL_VALUES = {
  uid: "",
  firstName: "",
  lastName: "",
  password: "",
  confirmPassword: "",
  questionId: "",
  securityAnswer: "",
};